import React, { createContext, useRef, useCallback, useReducer } from 'react'
import { filterTemplates } from './admin_templates/filter'
import { deleteTemplate, toggleActive } from './admin_templates/actions'

const store = createContext({})

const { Provider } = store

const actions = {
  SET_QUERY: 'SET_QUERY',
  SET_STATUS: 'SET_STATUS',
  TOGGLE_DELETE_MODAL: 'TOGGLE_DELETE_MODAL',
  DELETE_TEMPLATE: 'DELETE_TEMPLATE',
  SET_DELETE_ERROR: 'SET_DELETE_ERROR',
  TEMPLATE_DELETED: 'TEMPLATE_DELETED',
  TOGGLE_ACTIVE: 'TOGGLE_ACTIVE',
  SET_TOGGLING: 'SET_TOGGLING',
  SET_TEMPLATE_ACTIVE: 'SET_TEMPLATE_ACTIVE',
  REPLACE_TEMPLATE: 'REPLACE_TEMPLATE',
}

const useEnhancedReducer = (reducer, initState, initializer) => {
  const lastState = useRef(initState)
  const getState = useCallback(() => lastState.current, [])
  return [
    ...useReducer(
      (state, action) => lastState.current = reducer(state, action),
      initState,
      initializer,
    ),
    getState,
  ]
}

const reduce = (state, action) => {
  switch (action.type) {
    case actions.SET_QUERY:
      return { ...state, query: action.payload }
    case actions.SET_STATUS:
      return { ...state, status: action.payload }
    case actions.TOGGLE_DELETE_MODAL:
      return { ...state, deleteOpen: !state.deleteOpen, templateToDelete: action.payload || state.templateToDelete }
    case actions.SET_DELETING:
      return { ...state, deleting: action.payload }
    case actions.SET_DELETE_ERROR:
      return { ...state, deleteError: action.payload, deleting: false }
    case actions.SET_TOGGLING:
      return { ...state, toggling: action.payload.id }
    case actions.SET_TEMPLATE_ACTIVE:
      return {
        ...state,
        toggling: null,
        templates: state.templates.map(template => template.id === action.payload.id ? action.payload : template)
      }
    case actions.TEMPLATE_DELETED:
      return {
        ...state,
        deleting: false,
        deleteOpen: false,
        templateToDelete: null,
        templates: state.templates.filter(template => template.id !== action.payload),
      }
    case actions.REPLACE_TEMPLATE:
      return {
        ...state,
        templates: state.templates.map(template => template.id === action.payload.id ? action.payload : template)
      }
    default:
      return state
  }
}

const StateProvider = (props) => {
  const initialState = {
    ...props,
    templates: props.templates.data,
    status: 'all',
    query: '',
    deleting: false,
    deleteOpen: false,
    templateToDelete: null,
    toggling: null,
  }

  const [state, dispatch, getState] = useEnhancedReducer(reduce, initialState)

  const asyncDispatch = (action) => {
    const state = getState()
    switch (action.type) {
      case actions.DELETE_TEMPLATE:
        deleteTemplate(state, dispatch)
        return dispatch({ type: actions.SET_DELETING, payload: true })
      case actions.TOGGLE_ACTIVE:
        toggleActive(state, action, dispatch)
        return dispatch({ type: actions.SET_TOGGLING, payload: action.payload })
      default:
        return dispatch(action)
    }
  }

  const usableData = {
    ...state,
    templates: filterTemplates(state.templates, state.status, state.query),
    actions,
  }

  const value = {
    ...usableData,
    dispatch: asyncDispatch.bind(usableData)
  }

  return <Provider value={value}>{props.children}</Provider>
}

export { store, StateProvider, actions }
